import { useCallback, useEffect, useState } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroSection from "@/pages/home/components/HeroSection";
import Breadcrumb from "@/pages/home/components/Breadcrumb";
import ChannelDirectory from "@/pages/home/components/ChannelDirectory";
import TrendingSection from "@/pages/home/components/TrendingSection";
import HotRanking from "@/pages/home/components/HotRanking";
import SiteMapSection from "@/pages/home/components/SiteMapSection";
import FaqSection from "@/pages/home/components/FaqSection";
import BrandSection from "@/pages/home/components/BrandSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import StructuredData from "@/pages/home/components/StructuredData";

export default function Home() {
  const [query, setQuery] = useState("");
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 640);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSearch = useCallback(() => {
    document.getElementById("channels")?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <StructuredData />
      <SiteHeader />

      <main className="w-full">
        <HeroSection query={query} onQueryChange={setQuery} onSearch={handleSearch} />
        <Breadcrumb />
        <ChannelDirectory query={query} onQueryChange={setQuery} />
        <TrendingSection />
        <HotRanking />
        <SiteMapSection />
        <FaqSection />
        <BrandSection />
        <SubscribeSection />
      </main>

      <SiteFooter />

      <button
        type="button"
        onClick={scrollToTop}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer ${
          showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
        }`}
      >
        <i className="ri-arrow-up-line text-xl" />
      </button>
    </div>
  );
}